import axios from "axios";
import React, { useEffect, useState } from "react";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../components/loading/Loading";

function Editrole() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const [category, setcategory] = useState();
  const [role, setrole] = useState();
  const [description, setdescription] = useState();
  const [menu, setmenu] = useState();
  const [report, setreport] = useState();
  const { id } = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/roles/${id}`);
    handlesetEdit(result.data.data[0]);
    setcategory(result.data.data[0].category);
    setrole(result.data.data[0].role);
    setdescription(result.data.data[0].description);
    setmenu(result.data.data[0].menu);
    setreport(result.data.data[0].report);
  };

  const [add, setAdd] = useState({
    category: "",
    role: "",
    description: "",
    menu: "",
    report: "",
  });

  const handlesetEdit = (data) => {
    console.log(data);
    setAdd({
      category: data.category,
      role: data.role,
      description: data.description,
      menu: data.menu,
      report: data.report,
    });
  };

  const addRole = async () => {
    if (
      add.category !== "" ||
      add.role !== "" ||
      add.description !== "" ||
      add.menu !== "" ||
      add.report !== ""
    ) {
      setLoading(true);
      await axios.patch(`https://mobile.amospa.com/roles/${id}`, add);
      setLoading(false);
      setTitle("Success Edit Role");
      setModalShow(true);
    } else {
      setTitle("No Data Change");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/setting/role/");
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-role">
                <div className="header-add-role">
                  <h5 className="m-0">Update Role</h5>
                </div>
                <div className="form-add-role">
                  <div className="wrapper-data">
                    <label>Category</label>
                    <input
                      type="text"
                      name="category"
                      onChange={(e) =>
                        setAdd({ ...add, category: e.target.value })
                      }
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>Role</label>
                    <input
                      type="text"
                      name="role"
                      onChange={(e) => setAdd({ ...add, role: e.target.value })}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>Description</label>
                    <input
                      type="text"
                      name="description"
                      onChange={(e) =>
                        setAdd({ ...add, description: e.target.value })
                      }
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>List Menu</label>
                    <input
                      type="text"
                      name="menu"
                      onChange={(e) => setAdd({ ...add, menu: e.target.value })}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>List Report</label>
                    <input
                      type="text"
                      name="report"
                      onChange={(e) =>
                        setAdd({ ...add, report: e.target.value })
                      }
                    />
                  </div>
                  <button className="text-white" onClick={() => addRole()}>
                    Update Role
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" ? handleNext : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Editrole;
